export const INIT_ONBOARDING = 'vtn-component-user-onboarding/INIT_ONBOARDING';
export const INIT_ONBOARDING_SUCCESS =
  'vtn-component-user-onboarding/INIT_ONBOARDING_SUCCESS';

export const KILL_ONBOARDING = 'vtn-component-user-onboarding/KILL_ONBOARDING';

export const actionInit = () => ({
  type: INIT_ONBOARDING,
});

export const actionInitSuccess = () => ({
  type: INIT_ONBOARDING_SUCCESS,
});

export const actionKillOnboarding = () => ({
  type: KILL_ONBOARDING,
});
